import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  Expenses = 'Expenses',
}

export const queryKeys = {
  expenses: (clientId: string) => [QueryFeature.Profile, QueryKey.Expenses, clientId],
};
